'use client'
import { type RefObject, useEffect } from 'react'

function useSubmit({ formRef, dependency }: { formRef: RefObject<HTMLFormElement | null>; dependency: unknown }) {
  useEffect(() => {
    if (!formRef.current) return
    formRef.current.requestSubmit()
  }, [dependency, formRef])
}

export default useSubmit
